import React from 'react';
import { Chip } from '@mui/material';
import { Close } from '@mui/icons-material';

const TagChip = ({ tag, onDelete, size = 'small', ...props }) => {
  return (
    <Chip
      label={tag.name}
      size={size}
      sx={{
        backgroundColor: tag.color,
        color: '#fff',
        fontWeight: 500,
        '& .MuiChip-deleteIcon': {
          color: 'rgba(255, 255, 255, 0.7)',
          '&:hover': {
            color: '#fff'
          }
        },
        ...props.sx
      }}
      onDelete={onDelete}
      deleteIcon={onDelete ? <Close /> : undefined}
      {...props}
    />
  );
};

export default TagChip;

